import React, { useRef } from "react";
import styles from "./IR330C.module.scss";

const IR330CPersonName = (props) => {
  const { setNameData, firstName, surName, setIRDData, IRD } = props;
  const irdDivRef = useRef(null);

  const onTextChange = (e) => {
    setNameData({ name: e.target.name, value: e.target.value });
  };

  const onIRDChange = (e) => {
    const { name, value } = e.target;
    const index = name.replace("IRD", "");
    if (irdDivRef.current.children.length > index) {
      irdDivRef.current.children[index].children[0].focus();
    }
    setIRDData({ name, value });
  };
  return (
    <div className={styles.irdInnerDetails + " pb-3"}>
      <div className="row">
        <div className="col-sm-12 col-md-8 col-lg-6">
          <div className={styles.irdInnerDetailsTitle + " mb-2"}>
            1 <span className="pl-3">Your details</span>
          </div>
        </div>
      </div>
      <div className={styles.rowMargin + " row"}>
        <div className="col-sm-12 col-md-6 col-lg-6 ">
          <div className="form-group">
            <label htmlFor="fname" className="d-flex">
              First name(s) - in full
            </label>
            <input type="text" id="firstName" name="firstName" className="form-control inputbox-name" value={firstName} onChange={onTextChange} required={true} />
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6">
          <label htmlFor="surName" className="d-flex">
            Family name
          </label>
          <input type="text" id="surName" name="surName" className="form-control inputbox-name" value={surName} onChange={onTextChange} required={true} />
        </div>
      </div>
      <div className={styles.rowMargin + " row"}>
        <div className="col-md-3">
          <label>IRD number</label>
        </div>
        <div className="col-md-6">
          <label className="d-flex eightdigit-number-whitebox">
            (8 digit numbers start in the second box.
            <span />
            {[...Array(8).keys()].map((i) => {
              return <span key={`IRD_span_${i}`}>{i + 1}</span>;
            })}
            )
          </label>
        </div>
        <div className="col-md-3">
          <div className="eightdigit-number-inputbox" ref={irdDivRef}>
            {[...Array(9).keys()].map((i) => {
              const cl = i + (1 % 3) === 0 ? "inputbox sm-mr-1" : "inputbox";
              return (
                <div key={`IRD_Div_${i}`} className={cl}>
                  <input maxLength="1" type="text" key={`IRD${i + 1}`} id={`IRD${i + 1}`} name={`IRD${i + 1}`} className="w-100" value={IRD[i]} onChange={onIRDChange} required={i > 0 ? true : false} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IR330CPersonName;
